// import React from 'react';
// import { useSelector } from 'react-redux';
// import { Navigate, useLocation } from 'react-router-dom';


// const ProtectedRoute = ({ children }) => {
//   const isAuthenticated = useSelector((state) => state.login.isAuthenticated);

//   const token = localStorage.getItem('dannytk');


//   return isAuthenticated && token ?  children : <Navigate to="/login" />;
// };

// export default ProtectedRoute;



import { Navigate } from 'react-router-dom';

function ProtectedRoute({ isAuthenticated, children }) {
  return isAuthenticated ? children : <Navigate to="/login" />;
}

export default ProtectedRoute;